module.exports = __webpack_public_path__ + "img/多渠道数据整合.54ac255c.png";